import React, {PureComponent} from "react";
import {Button, Platform, Text, View, FlatList, ScrollView, TouchableOpacity, Dimensions} from "react-native";
import {connect} from "react-redux";
import styles from "./styles";
//import store from "../../../redux/store";
//import {Tools} from "../../../tools/Tools";
import {useIsDrawerOpen} from '@react-navigation/drawer';
//import {useLinkTo} from "@react-navigation/native";

const instructions = Platform.select({
    ios: "Press Cmd+R to reload,\nCmd+D or shake for dev menu",
    android:
        "Double tap R on your keyboard to reload,\n" +
        "Shake or press menu button for dev menu",
    web: "Your browser will automatically refresh as soon as you save the file."
});

class HomeScreen extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            indexSelectType: 0,
        }
    }

    render() {
        const {navigation} = this.props;
       // const linkTo = useLinkTo();

        return (

            <View style={[styles.container
               // ,{height: Dimensions.get("window").height}
                ]}>
                <Text style={{fontSize:40}}>
                    {
                        this.props.route ?
                            this.props.route.name : null
                    }
                </Text>
           {/*     <Button
                    title="Go to Wojciech's profile"
                    onPress={() => linkTo("/stack/user/Wojciech/22")}
                />*/}
                <Button
                    title="Go to unknown profile"
                    onPress={() => navigation.navigate("Profile")}
                />
                <View style={{height: 60}}>
                    <FlatList
                        //   inverted={true}
                        keyboardShouldPersistTaps="handled"

                        style={{
                            // height: 10,
                            marginVertical: 10,
                            alignSelf: 'center'
                        }}
                        //  data={data.results.all_categories}
                        data={[{id: 1, name: 'متوفی'}, {id: 2, name: 'شهید'}]}

                        renderItem={({item, index}) =>

                            <TouchableOpacity
                                onPress={() => {
                                    // props.navigation.toggleRightDrawer()
// alert(useIsDrawerOpen())
//                                 if (useIsDrawerOpen())
//                                 this.props.navigation.openDrawer()
//                                 else
                                    this.props.navigation.toggleDrawer()
                                    this.setState({
                                        indexSelectType: index,
                                        type: item.id
                                    })
                                }
                                }
                                style={{
                                    paddingHorizontal: 3,
                                    backgroundColor: "#e4b4ee",
                                    //backgroundColor: Colors.gray,
                                    borderRadius: 10,
                                    marginHorizontal: 2,
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Text>{(item.name)}</Text>
                                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                {/*<HMTextView text={item.name} type={"bold"}*/}
                                {/*style={{*/}
                                {/*color: Colors.white,*/}
                                {/*marginHorizontal: moderateScale(6),*/}
                                {/*fontSize: moderateScale(13),*/}
                                {/*textAlign: 'center',*/}
                                {/*paddingHorizontal: moderateScale(4)*/}
                                {/*}}/>*/}


                            </TouchableOpacity>
                        }
                        horizontal={true}
                        showsHorizontalScrollIndicator={false}
                        keyExtractor={(item, index) => index.toString()}
                        inverted={true}
                    />
                </View>
                <View style={{flex: 1, backgroundColor: "#7bee9b", flexDirection: 'row'}}>
                    <View style={{flex: .8, backgroundColor: "#ee2113"}}>
                        <Text>
                            Welcome to React Native Web universal app!
                        </Text>
                    </View>
                    <View style={{flex: .2, backgroundColor: "#82abee", overflow: 'hidden'}}>
                        <Text style={{fontSize: 20}}>
                            Welcome to React Native Web universal app!
                        </Text>
                    </View>
                </View>
                <Text style={styles.welcome}>
                    Welcome to React Native Web universal app!
                </Text>
                <Text style={styles.instructions}>
                    This component is shared between web and react environment. To see how
                    it works, just edit the HomeScreen.js
                </Text>
                <Text style={styles.instructions}>{instructions}</Text>
                <Button
                    title="HomeDrawer"
                    onPress={() => navigation.navigate("HomeDrawer")}
                />
                <Button
                    title="SupportScreen"
                    onPress={() => navigation.navigate("SupportScreen")}
                />
                <Button
                    title="SettingsScreen"
                    onPress={() => navigation.pop()}
                />
                <Button
                    title="BookmarkScreen"
                    onPress={() => navigation.navigate("HomeStackScreen")}
                />
            </View>
        );
    }
}

export default HomeScreen;
/*const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    {}
)(HomeScreen);*/
